module.exports = __webpack_public_path__ + "img/icone-busca-cel@2x.d5f7a560.png";